import React, {useState, ChangeEvent} from "react";
import Form from "../../../../components/common/form/Form";
import Modal from "../../../../components/common/form/Modal";
import {createOptionListForSelectTag} from "../../../../helpers/utils/Utils";
import InputField from "../../../../components/common/form/InputField";
import SelectField from "../../../../components/common/form/SelectField";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import {useUploadPaymentFileMutation} from "../paymentApi";
import {useDownloadPaymentTemplateMutation} from "../../../../app/utilityRequestsApi";

interface UploadPaymentModalProps {
    show: boolean;
    setShow: (show: boolean) => void;
    customerData?: any;
    setShowFailedPaymentsModal: (show: boolean) => void;
    setResponseObj: (response: any) => void;
}

const UploadPaymentModal: React.FC<UploadPaymentModalProps> = ({
                                                                   show,
                                                                   setShow,
                                                                   customerData
                                                               }) => {
    const [file, setFile] = useState<File | null>(null);
    const [customer, setCustomer] = useState<string>("");
    const [uploadPayment, uploadPaymentApiRes] = useUploadPaymentFileMutation();
    const [downloadPaymentTemplate] = useDownloadPaymentTemplateMutation();
    const [isDownloading, setIsDownloading] = useState(false);

    function getUploadFile(e: ChangeEvent<HTMLInputElement>) {
        const uploadFile = e.target.files?.[0] || null;
        setFile(uploadFile);
    }

    const downloadPaymentFile = async () => {
        if (isDownloading) return; // prevent double-clicks
        setIsDownloading(true);
        try {
            const blob = await downloadPaymentTemplate().unwrap();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "payment_template.csv");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download error:", error);
            alert("Failed to download file.");
        } finally {
            setIsDownloading(false);
        }
    };

    const handleSubmit = async (e:any) => {
       e.preventDefault();
        if (customer !== '' && file !== null) {
            const obj = {
                customerId: customer,
                file: file
            };
            const formData = new FormData();
            formData.append("file", file); // your backend must expect "file" key
            try {
                await uploadPayment(obj);
            } catch (error) {
                console.error("Upload failed", error);
            }
        }
    }

    return (
        <Modal
            title={"Upload Payment"}
            show={show}
            setShow={setShow}
            className={"w-2/6 bg-text-0 text-surface-0"}
            fields={
                <>
                    <Form onSubmit={handleSubmit} fields={
                        <>
                            <div className="modal-body">
                                <SelectField
                                    placeholder="Select Customer..."
                                    value={
                                        customerData?.data?.find((c: any) => c.id === customer)
                                            ? {
                                                label: customerData.data.find((c: any) => c.id === customer).customerName,
                                                value: customer,
                                            }
                                            : null
                                    }
                                    options={createOptionListForSelectTag(customerData.data, "customerName", "id")}
                                    onChange={(selectedOption) => {
                                        setCustomer(selectedOption?.value ?? "");
                                    }}
                                    label="Customer"
                                    required
                                />

                                <InputField
                                    type="file"
                                    name="file"
                                    accept={".csv,.xls,.xlsx"}

                                    label="File"
                                    onChange={getUploadFile}
                                    required/>


                                <div className="mt-2"/>
                                <span
                                    onClick={downloadPaymentFile}
                                    className={`font-data text-highlight-4 ${
                                        isDownloading ? "cursor-not-allowed opacity-60" : "cursor-pointer"
                                    }`}
                                    style={{textDecoration: "none"}}
                                >
                                  {isDownloading ? "Downloading..." : "Select Payment File (GF#, Payment, Check #, Payment Date (MM-dd-yyyy))"}
                                </span>
                            </div>

                            <div className="mt-4 border-t border-t-surface-5 flex justify-end">

                                <ButtonTray
                                    buttons={[
                                        {
                                            buttonProps: {
                                                btnText: "Cancel",
                                                onClick: () => setShow(false),
                                                type: "close",
                                            },
                                            buttonType: "button"
                                        },
                                        {
                                            buttonProps: {
                                                btnText: "Upload",
                                                type: "submit",
                                                isLoading: uploadPaymentApiRes.isLoading,
                                            },
                                            buttonType: "button",
                                        }
                                    ]}
                                    align={"center"}
                                    gap={2}
                                />

                            </div>
                        </>
                    }/>
                </>
            }
        />
    );
};

export default UploadPaymentModal;
